import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../hooks/use-auth';
import { useGlobalStore } from '@old/global-store/use-store';
import { PATH } from '@old/data/core/paths';

type ProtectedRouteProps = {
  admin?: boolean;
  redirectPath?: PATH;
};

export function ProtectedRoute({ admin, redirectPath = PATH.LOGIN }: ProtectedRouteProps) {
  // Wait for persisted state to hydrate to avoid false negatives on first render after F5
  const hasHydrated = useGlobalStore.persist?.hasHydrated?.() ?? true;
  const { isAuthenticated, isAdmin } = useAuth();
  const location = useLocation();

  if (!hasHydrated) return null; // or a loader placeholder

  const isAllowed = admin ? isAdmin : isAuthenticated;

  const loginUrl =
    location.pathname !== redirectPath
      ? `${redirectPath}?returnUrl=${encodeURIComponent(location.pathname)}`
      : redirectPath;

  return isAllowed ? <Outlet /> : <Navigate replace to={loginUrl} />;
}
